import { AlertTriangle, CheckCircle, XCircle } from 'lucide-react'

import { Badge } from '@/components/ui'
import type { ReplayCheckResult } from '@/types/replayLab'

/**
 * Red/green check chip. A FAILING advisory check (order/outcome) renders as
 * a distinct amber "advisory" chip — never destructive red. Those two checks
 * are structurally red in Phase 1 (the payment webhook can't reach a
 * text-only replay), and rendering them red would train admins to ignore red.
 */
export function CheckChip({ result }: { result: ReplayCheckResult }) {
  if (result.passed) {
    return (
      <Badge
        variant="success"
        title={result.detail}
        data-testid={`check-passed-${result.check}`}
      >
        <CheckCircle />
        {result.check}
      </Badge>
    )
  }
  if (result.advisory) {
    return (
      <Badge
        variant="outline"
        className="border-warning/50 text-warning-strong"
        title={result.detail}
        data-testid={`check-advisory-${result.check}`}
      >
        <AlertTriangle />
        {result.check} · advisory
      </Badge>
    )
  }
  return (
    <Badge
      variant="destructive"
      title={result.detail}
      data-testid={`check-failed-${result.check}`}
    >
      <XCircle />
      {result.check}
    </Badge>
  )
}
